export default __webpack_public_path__ + "static/SourceSansPro-Regular-efa76f8326aa5cee3bdd07d37e2a63d2.ttf";